import { Fragment } from 'react';
import { useFela } from 'react-fela';

import { FormattedMessage } from 'react-intl';

import { PageWrapper } from 'modules/layout';

import Images from '../../containers/Images';

import rule from './ImagesPage.rule';

const ImagesPage = () => {
    const { css } = useFela();

    return (
        <PageWrapper
            header={
                <Fragment>
                    <FormattedMessage id="images.page.title" />
                </Fragment>
            }
        >
            <div className={css(rule)}>
                <Images />
            </div>
        </PageWrapper>
    );
};

export default ImagesPage;
